import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      brand_tagline: "Anonymous Q&A",
      nav_browse: "Browse",
      nav_ask: "Ask",
      nav_login: "Login",
      nav_logout: "Logout",
      hero_title_a: "Ask anything,",
      hero_title_b: "anonymously",
      hero_subtitle: "Ask anonymously, get thoughtful community insights.",
      ask_placeholder: "What's your question?",
      ask_button: "Ask Question",
      anonymous_note: "No login needed • Completely anonymous",
      image_url_label: "Optional images (upload) — max 3",
      location_label: "Optional location",
      location_placeholder: "e.g., Mumbai",
      browse_title: "Recent Questions",
      browse_subtitle: "Browse first responses and community insights.",
      filter_all: "All",
      filter_unanswered: "Unanswered",
      filter_discussed: "Most Discussed",
      location_filter_placeholder: "Filter by location (city)",
      first_response: "System-generated first response",
      community_insights: "Community Insights",
      your_insight: "Your Insight",
      post_answer: "Post Answer",
      login_to_add: "Login to Add Your Insight",
      starter_insight: "Starter insight",
      share: "Share",
      report: "Report",
      reply: "Reply",
      submit_report: "Submit Report",
      profile_setup_title: "Set your alias",
      alias_label: "Alias (shown publicly)",
      alias_placeholder: "e.g., CuriousOwl",
      interests_label: "Interests (comma-separated)",
      save: "Save",
    },
  },
  hi: {
    translation: {
      brand_tagline: "गुमनाम प्रश्नोत्तर",
      nav_browse: "ब्राउज़",
      nav_ask: "पूछें",
      nav_login: "लॉगिन",
      nav_logout: "लॉगआउट",
      hero_title_a: "कुछ भी पूछें,",
      hero_title_b: "गुमनाम रूप से",
      hero_subtitle: "गुमनाम होकर पूछें, समुदाय से उपयोगी जवाब पाएं।",
      ask_placeholder: "आपका प्रश्न क्या है?",
      ask_button: "प्रश्न पूछें",
      anonymous_note: "लॉगिन की ज़रूरत नहीं • पूरी तरह गुमनाम",
      image_url_label: "वैकल्पिक इमेज (अपलोड) — अधिकतम 3",
      location_label: "वैकल्पिक लोकेशन",
      location_placeholder: "जैसे, मुंबई",
      browse_title: "हाल के प्रश्न",
      browse_subtitle: "पहले जवाब और समुदाय की राय देखें।",
      filter_all: "सभी",
      filter_unanswered: "बिना जवाब",
      filter_discussed: "सबसे ज्यादा चर्चा",
      location_filter_placeholder: "लोकेशन से फ़िल्टर करें",
      first_response: "सिस्टम द्वारा बनाया गया पहला जवाब",
      community_insights: "समुदाय की राय",
      your_insight: "आपकी राय",
      post_answer: "जवाब पोस्ट करें",
      login_to_add: "जवाब देने के लिए लॉगिन करें",
      starter_insight: "स्टार्टर राय",
      share: "शेयर",
      report: "रिपोर्ट",
      reply: "रिप्लाई",
      submit_report: "रिपोर्ट भेजें",
      profile_setup_title: "अपना एलियस सेट करें",
      alias_label: "एलियस (पब्लिक नाम)",
      alias_placeholder: "जैसे, CuriousOwl",
      interests_label: "रुचियाँ (कॉमा से अलग)",
      save: "सेव",
    },
  },
};

const saved = localStorage.getItem("askincog_lang") || "en";

i18n.use(initReactI18next).init({
  resources,
  lng: saved,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  localStorage.setItem("askincog_lang", lng);
}
